import { IConfiguredHttp } from './http';

export interface IIcalValidationApi {
	validateIcal: (url: string) => Promise<any>;
}

const icalValidationApiFactory = (http: IConfiguredHttp, prefix = ''): IIcalValidationApi => ({
	validateIcal(url: string) {
		return http.post(`${prefix}?url=${url}`);
	}
});

export default icalValidationApiFactory;
